export default __webpack_public_path__ + "static/media/wpicon.2d8daebb.png";